import React from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import Icon from "@material-ui/core/Icon";
import TeamMemberInfo from "./TeamMemberInfo";

const styles = theme => ({
  tooltip: {
    borderRadius: 8,
    padding: theme.spacing.unit,
    backgroundColor: "#000000",
    fontSize: 16
  },
  badge: {
    top: 14,
    right: -15,
    // The border color match the background color.
    border: `2px solid ${
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[900]
    }`
  }
});

class TeamMember extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      open: false
    };
  }

  handleClickOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  renderAvatar(isCreator, photoUrl, classes) {
    const image = photoUrl || require("../images/avatar.png");
    return isCreator ? (
      <Badge
        badgeContent={"C"}
        color="primary"
        classes={{ badge: classes.badge }}
      >
        <Avatar src={image} />
      </Badge>
    ) : (
      <Avatar src={image} />
    );
  }

  render() {
    const { classes, teamId, member } = this.props;
    const { open } = this.state;
    const isCreator = teamId === member.id;

    return (
      <ListItem dense button className={classes.listItem}>
        {this.renderAvatar(isCreator, member.photoUrl, classes)}
        <Tooltip
          title={member.intro || ""}
          classes={{ tooltip: classes.tooltip }}
        >
          <ListItemText primary={member.displayName} />
        </Tooltip>
        <ListItemSecondaryAction>
          <IconButton onClick={this.handleClickOpen}>
            <Icon>info</Icon>
          </IconButton>
        </ListItemSecondaryAction>
        <TeamMemberInfo
          visible={open}
          onClose={this.handleClose}
          member={member}
        />
      </ListItem>
    );
  }
}

export default withStyles(styles)(TeamMember);
